import { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import session from '../../../SessionHandler/session-helper';
import { toast } from 'react-toastify';
import { ADMIN } from '../../Usuario/Perfil';
import { useDispatch, useSelector } from 'react-redux';
import { setUsuario } from '../../Usuario/actions/actions';
import { save } from '../../Instituicao/api-instituicao';
import { changePhoto, removeUserPhoto, saveCurrentUser } from '../../Usuario/api-usuario';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import Button from '../../UI/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { makeStyles } from '@mui/styles';
import { PatternFormat } from 'react-number-format';
import GridPaper from '../../../util/GridPaper';

const useStyles = makeStyles({
    container: {
        paddingBottom: '20px'
    },
    submit: {
        marginTop: '20px',
        marginLeft: '20px'
    },
    fotoComponent: {
        width: '80px',
        borderRadius: '20px',
    },
    accountCircleIcon: {
        fontSize: 80,
        color: 'black'
    },
});

const Configuracao = () => {
    const [anoLetivo, setAnoLetivo] = useState();
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);
    const dispatch = useDispatch();
    const hiddenFileInput = useRef(null);
    const [isLoadingAction, setIsLoadingAction] = useState(false);
    const [usuarioPersist, setUsuarioPersist] = useState(null);

    useEffect(() => {
        setAnoLetivo(session.getAnoLetivo);
    }, [])

    useEffect(() => {
        if (usuario) {
            setUsuarioPersist(usuario);
        }
    }, [usuario]);

    const handleChangeAnoLetivo = (event) => {
        setAnoLetivo(event.target.value);

    };

    const handleAttachFile = () => {
        hiddenFileInput.current.click();
    }

    const handleChangeImage = e => {
        const file = e.target.files[0];

        if (file === null) {
            return;
        }

        const fileFormData = new FormData();
        fileFormData.append('file', file);

        setIsLoadingAction(true);
        changePhoto(usuario.id, fileFormData).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(setUsuario(data));
            }
            setIsLoadingAction(false);
        });
    };

    const handleRemoveImage = () => {
        setIsLoadingAction(true);
        removeUserPhoto(usuario.id).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(setUsuario(data));
            }
            setIsLoadingAction(false);
        })


    };

    const clickSubmit = (event) => {
        event.preventDefault();
        session.setAnoLetivo(anoLetivo);
        toast.success("Ano Letivo da plataforma alterado com sucesso.", {
            position: "bottom-left"
        });
        window.location.reload(false);

    }

    const handleSwitchChange = (name) => {
        let instituicao = {
            ...usuario.instituicao,
            [name]: !usuario.instituicao.comunicadoAprovacao
        }

        save(instituicao).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(
                    setUsuario(
                        {
                            ...usuario,
                            instituicao: data
                        }
                    )
                );
            }
        })

    };
    const handleChangeUsuarioForm = (event) => {
        setUsuarioPersist({
            ...usuarioPersist,
            [event.target.name]: event.target.value ? event.target.value : null
        })

    }

    const handleSaveUsuario = () => {
        saveCurrentUser(usuarioPersist).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    dispatch(setUsuario(data));
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                }
            }
        })
    }

    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Grid container direction='row' spacing={5}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6
                        }}>
                        <Grid container spacing={3}>
                            <Grid size={12}>
                                <Typography variant='h5'>
                                    Ano Letivo Escolar
                                </Typography>
                            </Grid>
                            <GridPaper size={12} >
                                <form onSubmit={clickSubmit}>
                                    <Grid container spacing={2} direction='row'>
                                        <Grid>
                                            <TextField
                                                variant="outlined"
                                                margin="normal"
                                                label="Ano Letivo"
                                                name="anoLetivo"
                                                autoFocus
                                                onChange={handleChangeAnoLetivo}
                                                value={anoLetivo ? anoLetivo : ''}
                                            />
                                        </Grid>
                                        <Grid>
                                            <Button
                                                type="submit"
                                                color="primary"
                                                className={classes.submit}>
                                                Salvar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </GridPaper>
                        </Grid>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6
                        }}>
                        <Grid container spacing={3}>
                            <Grid size={12}>
                                <Typography variant='h5'>Meus Dados</Typography>
                            </Grid>
                            <GridPaper size={12}>
                                <Grid container spacing={3}>
                                    <Grid size={12}>
                                        <Typography variant='body1'>{usuario.nome}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <div style={{ border: '1px', borderStyle: 'solid', padding: '20px' }}>
                                            <Grid size={12}>
                                                <Typography variant='body1'>Foto Perfil:</Typography>
                                            </Grid>
                                            <Grid size={12}>
                                                <Grid container direction='row' spacing={3}>
                                                    <Grid>
                                                        {usuario && usuario.fileName ?
                                                            <img
                                                                src={usuario.fotoUrl}
                                                                alt=''
                                                                className={classes.fotoComponent}
                                                            /> :
                                                            <AccountCircle className={classes.accountCircleIcon} />
                                                        }

                                                    </Grid>
                                                    <Grid>
                                                        <Grid container direction='column' alignItems='center' spacing={1}>
                                                            <Grid>
                                                                <input
                                                                    type="file"
                                                                    accept=".jpg,.jpeg,.png"
                                                                    style={{ display: 'none' }}
                                                                    ref={hiddenFileInput}
                                                                    onChange={handleChangeImage}
                                                                    multiple={false}
                                                                />
                                                                <Button
                                                                    disabled={isLoadingAction}
                                                                    onClick={handleAttachFile}
                                                                >
                                                                    Alterar Foto
                                                                </Button>
                                                            </Grid>
                                                            <Grid>
                                                                <Button
                                                                    disabled={isLoadingAction}
                                                                    color='secondary'
                                                                    onClick={handleRemoveImage}
                                                                >
                                                                    Remover Foto
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>

                                    <Grid size={3}>
                                        <Typography variant='body1'>
                                            CPF:
                                        </Typography>
                                        {/* <InputMask
                                            mask="999.999.999-99"
                                            name="cpfCnpj"
                                            placeholder='XXX.XXX.XXX-XX'
                                            onChange={handleChangeUsuarioForm}
                                            value={usuarioPersist && usuarioPersist.cpfCnpj ? usuarioPersist.cpfCnpj : ''}
                                            maskchar="_"
                                        /> */}
                                        <PatternFormat
                                            format="###.###.###-##"
                                            allowEmptyFormatting
                                            mask="_"
                                            placeholder='XXX.XXX.XXX-XX'
                                            onChange={handleChangeUsuarioForm}
                                            value={usuarioPersist && usuarioPersist.cpfCnpj ? usuarioPersist.cpfCnpj : ''}
                                            name="cpfCnpj"
                                        />


                                    </Grid>
                                    <Grid size={12}>
                                        <Button onClick={handleSaveUsuario}>Salvar</Button>
                                    </Grid>
                                </Grid>
                            </GridPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {
                usuario && usuario.perfil === ADMIN ?
                    <>
                        <Grid size={12}>
                            <Typography variant='h5'>Configurações Admin Plataforma</Typography>
                        </Grid>
                        <GridPaper size={12}>
                            <Grid container spacing={3}>
                                <Grid size={12}>
                                    <FormControlLabel
                                        control={
                                            <div style={{ marginLeft: '45px' }}>
                                                <Switch
                                                    color="primary"
                                                    checked={usuario &&
                                                        usuario.instituicao.comunicadoAprovacao ?
                                                        true :
                                                        false
                                                    }
                                                    onChange={() => handleSwitchChange('comunicadoAprovacao')}
                                                    value={usuario &&
                                                        usuario.instituicao.comunicadoAprovacao ?
                                                        true :
                                                        false
                                                    }
                                                />
                                            </div>
                                        }
                                        label="Comunicado Aprovação Habilitador"
                                        labelPlacement="start"
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <FormControlLabel
                                        control={
                                            <div style={{ marginLeft: '45px' }}>
                                                <Switch
                                                    color="primary"
                                                    checked={usuario &&
                                                        usuario.instituicao.smsLembreteHabilitado ?
                                                        true :
                                                        false
                                                    }
                                                    onChange={() => handleSwitchChange('smsLembreteHabilitado')}
                                                    value={usuario &&
                                                        usuario.instituicao.smsLembreteHabilitado ?
                                                        true :
                                                        false
                                                    }
                                                />
                                            </div>
                                        }
                                        label="SMS Lembrete Habilitado"
                                        labelPlacement="start"
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <FormControlLabel
                                        control={
                                            <div style={{ marginLeft: '45px' }}>
                                                <Switch
                                                    color="primary"
                                                    checked={usuario &&
                                                        usuario.instituicao.smsPendenciaHabilitado ?
                                                        true :
                                                        false
                                                    }
                                                    onChange={() => handleSwitchChange('smsPendenciaHabilitado')}
                                                    value={usuario &&
                                                        usuario.instituicao.smsPendenciaHabilitado ?
                                                        true :
                                                        false
                                                    }
                                                />
                                            </div>
                                        }
                                        label="SMS Pendência Habilitado"
                                        labelPlacement="start"
                                    />
                                </Grid>
                            </Grid>
                        </GridPaper>
                    </>
                    : ''
            }
        </Grid >
    );
}

export default Configuracao;